import type { SurveySummary } from '@/types/residents/corkBoard';

/** Lens applied to the Surveys list. Chips overlap (responded+closed) by design. */
export type SurveyStatusFilter = 'all' | 'toAnswer' | 'responded' | 'closed';

/** Chip options for FilterChipGroup, in display order. */
export const SURVEY_STATUS_FILTER_OPTIONS: { value: SurveyStatusFilter; label: string }[] = [
  { value: 'all', label: 'All' },
  { value: 'toAnswer', label: 'To answer' },
  { value: 'responded', label: 'Responded' },
  { value: 'closed', label: 'Closed' },
];

/**
 * Closed = the backend flag OR a lapsed expiry. The expiry re-check keeps a
 * cached list honest after a survey lapses, mirroring
 * countSurveysAwaitingResponse.
 */
function isSurveyClosed(survey: SurveySummary, now: number): boolean {
  if (survey.isClosed) return true;
  return !!survey.expiresAt && new Date(survey.expiresAt).getTime() <= now;
}

/**
 * Predicate for the Surveys screen status chips. Rows without a survey
 * payload only pass the "all" lens.
 */
export function matchesSurveyFilter(
  survey: SurveySummary | undefined,
  filter: SurveyStatusFilter,
  now: number = Date.now(),
): boolean {
  if (filter === 'all') return true;
  if (!survey) return false;
  switch (filter) {
    case 'toAnswer':
      return !isSurveyClosed(survey, now) && !survey.hasResponded;
    case 'responded':
      return survey.hasResponded;
    case 'closed':
      return isSurveyClosed(survey, now);
  }
}
